import axios from 'axios'
import applyCaseMiddleware from 'axios-case-converter'
const { baseURL, nonce, partnerKey, accessToken, uuid, pluginDir } =
  window.marketgoo

// TODO: Pending to remove selectors and implement it on usePost directly
// TODO: Pending replace _marketgoo-development with variable
export const selectors = {
  description: `_${pluginDir}_${uuid}_description`,
  keyword: `_${pluginDir}_${uuid}_keyword`,
  keywordId: `_${pluginDir}_${uuid}_keywordId`,
  score: `_${pluginDir}_${uuid}_score`,
  title: `_${pluginDir}_${uuid}_title`,
}

export const headers = {
  [`${partnerKey}-authorization`]: `Bearer ${accessToken}`,
  'X-WP-Nonce': nonce || false,
}

export const baseRequest = axios.create({
  baseURL,
  headers,
})

export const request = applyCaseMiddleware(baseRequest, {
  ignoreHeaders: true,
  preservedKeys: ['keywordId', ...Object.values(selectors)],
})

const GET = 'GET'
const POST = 'POST'

const metaTagsGenerator = {
  create: ({ url, keyword }) => ({
    url: `${partnerKey}/v1/metatags/autocomplete`,
    method: POST,
    data: { url, keyword },
  }),
}

const checks = {
  create: (body) => ({
    url: `${partnerKey}/v1/checks`,
    method: POST,
    data: body,
  }),
  get: (id) => ({
    url: `${partnerKey}/v1/checks/${id}`,
    method: GET,
  }),
}

// keywords: caballo
const keywordSearch = {
  read: (keywords) => ({
    url: `${partnerKey}/v1/keyword-search`,
    method: POST,
    data: keywords,
  }),
}

const recommendedKeyword = {
  read: ({ hash, data }) => ({
    url: `${partnerKey}/v1/suggest-recommend-keyword/${hash}`,
    method: POST,
    data,
  }),
}

const meta = {
  create: ({ postId, data }) => ({
    url: `${partnerKey}/v1/page/create/${postId}/meta`,
    method: POST,
    data,
  }),
  read: ({ popId, key }) => ({
    url: `${partnerKey}/v1/page/${popId}/meta/${key}`,
    method: GET,
  }),
}

const ctas = {
  read: () => ({ url: `${partnerKey}/v1/ctas`, method: GET }),
}

const dataAccount = {
  get: () => ({ url: `${partnerKey}/v1/data`, method: GET }),
}

const tokenStatus = {
  read: () => ({ url: `${partnerKey}/v1/token-status`, method: POST }),
}

const popTypes = {
  page: 'pages',
  post: 'posts',
}

const searchAppearanceDescription = {
  get: ({ id, type }) => ({
    url: `${partnerKey}/v1/${popTypes[type]}/${id}/description`,
    method: GET,
  }),
}

const searchAppearanceTitle = {
  get: ({ id, type }) => ({
    url: `${partnerKey}/v1/${popTypes[type]}/${id}/title`,
    method: GET,
  }),
}

const events = {
  create: (data) => ({
    url: `${partnerKey}/v1/events`,
    method: POST,
    data,
  }),
}

const wpNS = '/wp/v2'

/**
 * WordPress REST API endpoints for posts.
 * @see https://developer.wordpress.org/rest-api/reference/posts/
 */
const posts = {
  /**
   * Get a post or list of posts from the WordPress REST API.
   * @param {number} [id] - The post ID. If omitted, returns all posts.
   * @returns {object} Axios request config for fetching post(s).
   * @property {string} url - The endpoint URL.
   * @property {string} method - The HTTP method.
   */
  get: (id) => ({
    url: id ? `${wpNS}/posts/${id}` : `${wpNS}/posts`,
    method: GET,
  }),
  /**
   * Edit a post in the WordPress REST API.
   * @param {object} params - Parameters for editing a post.
   * @param {number} params.postId - The post ID.
   * @param {object} params.data - The data to update. Example: { title: string, content: string, ... }
   * @returns {object} Axios request config for editing a post.
   * @property {string} url - The endpoint URL.
   * @property {string} method - The HTTP method.
   * @property {object} data - The data to send in the request body.
   */
  edit: ({ postId, data } = {}) => ({
    url: `${wpNS}/posts/${postId}`,
    method: POST,
    data,
  }),
}

/**
 * WordPress REST API endpoints for pages.
 * @see https://developer.wordpress.org/rest-api/reference/pages/
 */
const pages = {
  /**
   * Get a page or list of pages from the WordPress REST API.
   * @param {number} [id] - The page ID. If omitted, returns all pages.
   * @returns {object} Axios request config for fetching page(s).
   * @property {string} url - The endpoint URL.
   * @property {string} method - The HTTP method.
   */
  get: (id) => ({
    url: id ? `${wpNS}/pages/${id}` : `${wpNS}/pages`,
    method: GET,
  }),
}

/**
 * WordPress REST API endpoints for posts or pages (pop).
 */
const pop = {
  /**
   * Get a post or page from the WordPress REST API.
   * @param {object} params - Parameters for fetching a post or page.
   * @param {number} params.id - The post or page ID.
   * @param {string} params.type - The type: 'post' or 'page'.
   * @returns {object} Axios request config for fetching a post/page.
   * @property {string} url - The endpoint URL.
   * @property {string} method - The HTTP method.
   */
  get: ({ id, type }) => ({
    url: `${wpNS}/${popTypes[type]}/${id}`,
    method: GET,
  }),
  /**
   * Edit a post or page in the WordPress REST API.
   * @param {object} params - Parameters for editing a post or page.
   * @param {number} params.id - The post or page ID.
   * @param {string} params.type - The type: 'post' or 'page'.
   * @param {object} params.data - The data to update. Example: { title: string, content: string, ... }
   * @returns {object} Axios request config for editing a post/page.
   * @property {string} url - The endpoint URL.
   * @property {string} method - The HTTP method.
   * @property {object} data - The data to send in the request body.
   */
  edit: ({ id, type, data } = {}) => ({
    url: `${wpNS}/${popTypes[type]}/${id}`,
    method: POST,
    data,
  }),
}

export const endpoints = {
  searchAppearanceDescription,
  searchAppearanceTitle,
  metaTagsGenerator,
  checks,
  ctas,
  dataAccount,
  events,
  keywordSearch,
  meta,
  pages,
  pop,
  posts,
  recommendedKeyword,
  tokenStatus,
}
